import Vue from 'vue'
import VueRouter from 'vue-router'
// --------------------------------------------------------------------------------- //
// 認証外
import LoginPage from '../views/public/LoginPage.vue';
import ForgetPassword from '../views/public/ForgetPassword.vue';
import PasswordReset from '../views/public/PasswordReset.vue';
// --------------------------------------------------------------------------------- //
// 共通
import ProfileSetting from '../views/common/ProfileSetting.vue';
import IssueDetails from '../views/common/IssueDetails.vue';
import TermsOfService from '../views/common/TermsOfService.vue';
// --------------------------------------------------------------------------------- //
// 顧客用画面
import CustomerTopPage from '../views/customer/CustomerTopPage.vue';
import SupportRequestRegist from '../views/customer/SupportRequestRegist.vue';

// --------------------------------------------------------------------------------- //
// カスタマーサポート用機能
import SupporterTopPage from '../views/supporter/SupporterTopPage.vue';
import CustomerSelect from '../views/supporter/CustomerSelect.vue';
import MemberList from '../views/supporter/MemberList.vue';
import IssueRegist from '../views/supporter/IssueRegist.vue';

import IssueList from '../views/supporter/IssueList.vue';
import IssueEdit from '../views/supporter/IssueEdit.vue';

// --------------------------------------------------------------------------------- //
import CustomerList from '../views/admin/CustomerList.vue';
import CustomerRegist from '../views/admin/CustomerRegist.vue';
import CustomerAttach from '../views/admin/CustomerAttach.vue';
import CustomerEdit from '../views/admin/CustomerEdit.vue';

// --------------------------------------------------------------------------------- //

Vue.use(VueRouter)

const routes = [
  // 認証外
  { // ログイン画面
    path: '/',
    name: 'Login',
    component: LoginPage,
  },
  { // パスワード変更
    path: '/forget-password',
    name: 'ForgetPassword',
    component: ForgetPassword,
  },
  { // パスワード再設定
    path: '/password-reset/:collisionId',
    name: 'PasswordReset',
    component: PasswordReset,
    props: true
  },
  // --------------------------------------------------------------------------------- //
  // 共通
  { // プロフィール設定
    path: '/common/profile-setting',
    name: 'ProfileSetting',
    component: ProfileSetting,
  },
  { // 問い合わせ確認（詳細）
    path: '/common/issue-details/:messageId',
    name: 'IssueDetails',
    component: IssueDetails,
    props: true
  },
  { // 利用規約確認
    path: '/common/terms-of-service',
    name: 'TermsOfService',
    component: TermsOfService,
  },
  // --------------------------------------------------------------------------------- //
  { // 顧客トップページ
    path: '/customer/customer-top-page',
    name: 'CustomerTopPage',
    component: CustomerTopPage,
  },
  { // 保守依頼登録
    path: '/customer/support-request-regist',
    name: 'SupportRequestRegist',
    component: SupportRequestRegist,
  },
  // --------------------------------------------------------------------------------- //
  { // サポートメンバートップページ
    path: '/supporter/supporter-top-page',
    name: 'SupporterTopPage',
    component: SupporterTopPage,
  },
  // --------------------------------------------------------------------------------- //
  { // 顧客選択
    path: '/supporter/customer-select',
    name: 'CustomerSelect',
    component: CustomerSelect,
  },
  { // 問い合わせ登録
    path: '/supporter/issue-regist',
    name: 'IssueRegist',
    component: IssueRegist,
    props:true,
  },
  // --------------------------------------------------------------------------------- //
  { // 問い合わせ一覧
    path: '/supporter/issue-list',
    name: 'IssueList',
    component: IssueList,
  },
  { // 問い合わせ編集
    path: '/supporter/issue-edit',
    name: 'IssueEdit',
    component: IssueEdit,
    props: true
  },
  { // サポートメンバ一覧
    path: '/supporter/member-list',
    name: 'MemberList',
    component: MemberList,
    props: true
  },
  // --------------------------------------------------------------------------------- //
  { // 顧客一覧
    path: '/admin/customer-list',
    name: 'CustomerList',
    component: CustomerList,
  },
  { // 顧客登録
    path: '/admin/customer-regist',
    name: 'CustomerRegist',
    component: CustomerRegist,
  },
  { // グループ割当(サポーター)
    path: '/admin/customer-attach',
    name: 'CustomerAttach',
    component: CustomerAttach,
    props: true
  },
  { // 顧客情報編集
    path: '/admin/customer-edit',
    name: 'CustomerEdit',
    component: CustomerEdit,
    props: true
  },
]

const router = new VueRouter({
  routes
})

export default router
